/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputEwZoneData } from './OutputEwZoneData';
import {
    OutputEwZoneDataFromJSON,
    OutputEwZoneDataFromJSONTyped,
    OutputEwZoneDataToJSON,
} from './OutputEwZoneData';

/**
 * 
 * @export
 * @interface OutputEwZonesResponse
 */
export interface OutputEwZonesResponse {
    /**
     * 
     * @type {Array<OutputEwZoneData>}
     * @memberof OutputEwZonesResponse
     */
    zones: Array<OutputEwZoneData>;
}

/**
 * Check if a given object implements the OutputEwZonesResponse interface.
 */
export function instanceOfOutputEwZonesResponse(value: object): boolean {
    if (!('zones' in value)) return false;
    return true;
}

export function OutputEwZonesResponseFromJSON(json: any): OutputEwZonesResponse {
    return OutputEwZonesResponseFromJSONTyped(json, false);
}

export function OutputEwZonesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputEwZonesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'zones': ((json['zones'] as Array<any>).map(OutputEwZoneDataFromJSON)),
    };
}

export function OutputEwZonesResponseToJSON(value?: OutputEwZonesResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'zones': ((value['zones'] as Array<any>).map(OutputEwZoneDataToJSON)),
    };
}

